export { MyMeetingsViewAdaptive as default } from "../../../navigation/ResponsiveScreens";
